import Api from '@/services/Api'

export default async function isLoggedIn() {
	let token = localStorage.getItem('token');

	if (!token) return false;

	return await Api().get(process.env.VUE_APP_QUERY_URL_SHOWS)
	.then(function () {
		return true;
	})
	.catch(function () {
		return false;
	});
}